<template>
   <div>
      <!-- <i :class="size + ' fas fa-circle dot'"></i>
      <i :class="size + ' fas fa-circle dot scnd'"></i>
      <i :class="size + ' fas fa-circle dot thrd'"></i> -->
      <div class="loading-box"><i class="fas fa-circle circle fa-2x"></i><div class="line lrg" /><div class="line sml" /></div>
      <div class="loading-box d2"><i class="fas fa-circle circle fa-2x"></i><div class="line lrg" /><div class="line sml" /></div>
      <div class="loading-box d3"><i class="fas fa-circle circle fa-2x"></i><div class="line lrg" /><div class="line sml" /></div>
      <div class="loading-box d4"><i class="fas fa-circle circle fa-2x"></i><div class="line lrg" /><div class="line sml" /></div>
      <div class="loading-box d5"><i class="fas fa-circle circle fa-2x"></i><div class="line lrg" /><div class="line sml" /></div>
   </div>
</template>

<script>
   import { mapStates, mapGetters, mapActions } from 'vuex'
   export default {
      props: {
         //Font awesome size
         size: {
            type: String,
            required: false,
            default: "fa-xs"
         },
      },
      computed: {
      },
      methods: {
      }
   }
</script>
